import React from 'react';
import { RecentActivity } from '../../types/types';
import moment from 'moment';

interface ActivityTimelineProps {
    activities: RecentActivity[];
}

const ActivityTimeline: React.FC<ActivityTimelineProps> = ({ activities }) => {

    if (activities.length === 0) {
        return (
            <div className="text-center py-4">
                <i className="bi bi-clock-history text-muted fs-1"></i>
                <p className="mt-3 text-muted">No activity history available for this candidate</p>
            </div>
        );
    }

    // Sort activities by timestamp, newest first
    const sortedActivities = [...activities].sort((a, b) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );

    const getActivityIcon = (type: string): string => {
        switch (type.toLowerCase()) {
            case 'stagechange':
                return 'bi-arrow-right-circle-fill';
            case 'note':
                return 'bi-journal-text';
            case 'documentupload':
                return 'bi-file-earmark';
            case 'email':
                return 'bi-envelope';
            case 'interview':
                return 'bi-calendar-event';
            default:
                return 'bi-clock-history';
        }
    };

    const getActivityColor = (type: string): string => {
        switch (type.toLowerCase()) {
            case 'stagechange':
                return 'success';
            case 'note':
                return 'info';
            case 'documentupload':
                return 'primary';
            case 'email':
                return 'warning';
            case 'interview':
                return 'danger';
            default:
                return 'secondary';
        }
    };

    return (
        <div className="timeline">
            {sortedActivities.map((activity, index) => (
                <div key={index} className="timeline-item mb-4">
                    <div className="d-flex">
                        <div className="me-3">
                            <div
                                className={`rounded-circle bg-${getActivityColor(activity.activityType)} text-white d-flex align-items-center justify-content-center`}
                                style={{ width: '40px', height: '40px', flexShrink: 0 }}
                            >
                                <i className={`bi ${getActivityIcon(activity.activityType)}`}></i>
                            </div>
                            {index < sortedActivities.length - 1 && (
                                <div
                                    className="timeline-connector"
                                    style={{
                                        width: '2px',
                                        height: '40px',
                                        backgroundColor: '#dee2e6',
                                        margin: '4px auto'
                                    }}
                                ></div>
                            )}
                        </div>
                        <div className="timeline-content" style={{ flex: 1 }}>
                            <div className="d-flex justify-content-between align-items-start mb-1">
                                <h6 className="mb-0 fw-bold">{activity.activityType}</h6>
                                <small className="text-muted">
                                    {moment(activity.timestamp).format('MMM D, YYYY [at] h:mm A')}
                                </small>
                            </div>
                            <div>
                                {activity.activityType.toLowerCase() === 'email' ? (
                                    <div dangerouslySetInnerHTML={{ __html: activity.description }} />
                                ) : (
                                    <p className="mb-1">{activity.description}</p>
                                )}
                                <div className="text-muted small">
                                    <i className="bi bi-person me-1"></i>
                                    {activity.userName}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ActivityTimeline;